import { Action, Mutation } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Resolve } from 'vue-di';
import { EdgeCouponApi, ProgramV2Api } from '@trialcard/apigateway.client';
import { Settings } from '~/services/settings';
import products from '~/assets/products';
import { IProduct } from '~/types/serviceTypes';

@InjectModule({ stateFactory: true }, module)
export default class ProgramModule extends InjectVuexModule {
    @Resolve
    public settings!: Settings;
    @Resolve
    public EdgeCouponApi!: EdgeCouponApi;
    @Resolve
    public programApi!: ProgramV2Api;

    public products: any[] = [];
    public copaySavingsCardId: string = '' as string;
    public promoId: number | null = null;
    public tcProgramId: number | null = null;
    public purchasedProduct: string = '' as string;
    public dynamicQPProgramId: number | null = null;
    public rebateProgramId = '286';

    getPurchasedProductDetails() {
        const product : IProduct | undefined = this.products.find((product: IProduct) => product.ndc === this.purchasedProduct);
        if(!product) throw new Error('Selected product not found');
        return product;
    }

    getProgramId() {
        const product = this.getPurchasedProductDetails();
        return product.dropTo === 'QP' ? this.dynamicQPProgramId : product.dropTo === 'L-DRIVE' ? Number(this.settings.clsProgramId) : null;
    }

    @Mutation
    public setCopaySavingsCardId(copaySavingsCardId: string) {
        this.copaySavingsCardId = copaySavingsCardId;
    }

    @Mutation
    public setProducts(products: any[]) {
        this.products = products;
    }

    @Mutation
    public setPromoId(promoId: number | null) {
        this.promoId = promoId;
    }

    @Mutation
    public setTcProgramId(tcProgramId: number | null) {
        this.tcProgramId = tcProgramId;
    }

    @Mutation
    public setPurchasedProduct(purchasedProduct: string) {
        this.purchasedProduct = purchasedProduct;
    }

    @Mutation
    public setdynamicQPProgramId(dynamicQPProgramId: number | null) {
        this.dynamicQPProgramId = dynamicQPProgramId;
    }

    @Action({ rawError: true })
    public async checkNumber(copaySavingsCardId: string): Promise<any> {
        const request = {
            memberId: copaySavingsCardId,
        };
        try {
            const response = await this.EdgeCouponApi.memberMemberNumberStatusWithProgram(request);
            return response?.data?.data || null;
        } catch (error) {
            return null;
        }
    }

    @Action({ rawError: true })
    public async getProrgamDetailsByPromoId(promoId: number): Promise<any> {
        const hasPromotion = true;
        const response = await this.programApi.programGetByTenantId('', hasPromotion, promoId);
        return response?.data?.data?.length && response?.data?.data[0] && response?.data?.data[0].programId ? response?.data?.data[0].programId : null;
    }

    @Action({ rawError: true })
    public clearStore() {
        this.context.commit('setCopaySavingsCardId', '');
        this.context.commit('setProducts', products);
        this.context.commit('setPromoId', null);
        this.context.commit('setTcProgramId', null);
        this.context.commit('setPurchasedProduct', '');
        this.context.commit('setdynamicQPProgramId', null);
    }
}
